export const chartsStyle = {
  data() {
    return {
      chartsStyles: null, // 风格配置
    }
  },
  watch: {
    chartsStyle: {
      deep: true,
      immediate: true,
      handler: function (nV) {
        this.chartsStyles = nV
        console.log('新的风格！！');
        this.$nextTick(() => {
          if (this.Configuration.isScaling) {
            this.throttle_resizeEcharts();
          } else if (this.Configuration.isMoving) {
            this.debounce_resizeEcharts();
          } else {
            this.debounce_subscribeConfigurationChange();
          }
        })


      }
    },
  },
  computed: {
    chartsStyle() {
      return this.ProjectInfo?.Style?.chartsStyle
    }
  },
}